import { useI18n } from '@change-corgi/core-react/i18n';

import { useLocalPageData } from '#src/app/pages/local/pageContext';

type Result = ModelHookResult<{
	signatureCountLabel: string | React.JSX.Element | React.JSX.Element[];
	totalVictoriesLabel: string | React.JSX.Element | React.JSX.Element[];
}>;

export function useLocalStats(): Result {
	const {
		data: { totalSignatureCount, totalSignatureCountLocalized, victoryCount, victoryCountLocalized },
	} = useLocalPageData();
	const { translatePluralHtml } = useI18n();

	return {
		data: {
			totalVictoriesLabel: translatePluralHtml('corgi.local.stats.victories', victoryCount, {
				countLocalized: victoryCountLocalized,
			}),
			signatureCountLabel: translatePluralHtml('corgi.local.stats.signatures', totalSignatureCount, {
				countLocalized: totalSignatureCountLocalized,
			}),
		},
	};
}
